// Table-of-contents helpers for markdown documents.

export const slugify = (text) => text
  .toLowerCase()
  .replace(/[^\w\s-]/g, '')
  .trim()
  .replace(/\s+/g, '-');

// Extracts h1-h4 headings (outside fenced code blocks) as
// [{ level, depth, text, id }] for the "Table of contents" sidebar.
//
// h1 counts because many migrated WordPress posts mark their sections with
// `#` — the Connectathon post's TOC listed only its three `##` subsections
// and none of its five sections (ocl_online#221). `depth` is the level
// relative to the document's shallowest heading, so a post written entirely
// in `####` isn't indented as if it were three levels deep.
//
// Markdown escapes are dropped from the text ("## 1\. What is…" — turndown
// escapes the period so it isn't read as a list); slugify strips the
// backslash too, so the id matches the rendered heading's either way.
const MARKDOWN_ESCAPE = /\\([\\`*_{}[\]()#+\-.!])/g;

export const extractHeadings = (markdown) => {
  const headings = [];
  let inFence = false;
  for (const line of markdown.split('\n')) {
    if (/^\s*(```|~~~)/.test(line)) {
      inFence = !inFence;
      continue;
    }
    const match = !inFence && line.match(/^(#{1,4})\s+(.+?)\s*#*\s*$/);
    if (match) {
      const text = match[2]
        .replace(MARKDOWN_ESCAPE, '$1')
        .replace(/[*_`~]/g, '')
        .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
      headings.push({ level: match[1].length, text, id: slugify(text) });
    }
  }
  const top = Math.min(...headings.map(heading => heading.level));
  return headings.map(heading => ({ level: heading.level, depth: heading.level - top, text: heading.text, id: heading.id }));
};
